import React, { FC } from "react";
import classNames from "classnames";
import { AssetsDirectory } from "@finbackoffice/enums";
import { Svg } from "../../svg/Svg";
import styles from "./modal-close-button.module.sass";

export enum ModalCloseButtonType {
    square = "square",
    corner = "corner",
    wallet = "wallet",
}

type ModalCloseButtonProps = {
    variant?: ModalCloseButtonType;
    onClick?: () => void;
};

const ModalCloseButton: FC<ModalCloseButtonProps> = ({ variant, onClick }) => {
    return (
        <Svg
            src={`/${AssetsDirectory.Common}/${AssetsDirectory.Mobile}/${AssetsDirectory.BaseIcons}/x-white.svg`}
            onClick={onClick}
            className={classNames(styles.close, variant && styles[variant])}
            testId="modal-close-button"
        />
    );
};

export default ModalCloseButton;
